module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: _vm.height,
      width: _vm.width,
      margin: _vm.margin
    })
  }, [(_vm.item.imageBig) ? _c('ImageModal', {
    attrs: {
      "image-small": _vm.actualPath,
      "width": _vm.width,
      "height": _vm.height,
      "image-big": _vm.getImgPath(_vm.item.imageBig),
      "caption": _vm.item.name,
      "align": _vm.align
    }
  }) : _c('img', {
    style: ({
      width: _vm.width,
      height: _vm.height,
      objectFit: 'contain'
    }),
    attrs: {
      "src": _vm.actualPath
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc3dfcde","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ItemImage.vue
// module id = 3380
// module chunks = 0